function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

const Session = {
  getCurrentOptions: () => {
    const encodedSessionValue = getParameterByName('session')
    if (encodedSessionValue) {
      const decodedSessionValue = window.atob(encodedSessionValue)
      try {
        return JSON.parse(decodedSessionValue)
      } catch (err) {
        console.error(err)
        return null
      }
    }
    return null
  }
}
export default Session;